<template>
    <b-container>
      <b-overlay :show="!moyenAccesOptions || facturation">
        <h3>
          Facturer un moyen d'accès
        </h3>
        <small >Contrat {{contrat}}</small>
          <b-row class=" mb-2">
            <small class="m-auto font-weight-bold">Cette action entraînera la facturation du locataire</small>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="selectionMoyenAcces"
                description="Choisir un moyen d'accès"
                >
                <b-form-select autofocus required :options="moyenAccesOptions" v-model="selectedMoyenAcces"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="selectionCouleur"
                description="Choisir une couleur"
                v-show="couleurOptions"
                >
                <b-form-select required :options="couleurOptions" v-model="selectedCouleur">
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button variant="primary" @click="addMoyenAcces" :disabled="!selectedMoyenAcces || (couleurOptions && !selectedCouleur)">
                <i class="fas fa-plus"></i> Ajouter
              </b-button>
            </b-col>
          </b-row>
          <hr />
          <b-row v-for="b in moyenAccesList" :key="b.id+'-'+b.count">
            <b-col>
              -  {{b.count}} {{b.libelletype}} {{b.couleur}} pour <strong >{{b.count*parseFloat(b.prix)}}€</strong>
            </b-col>
            <b-col cols="1" class="m-auto">
              <i class="fas fa-trash text-danger" @click="removeMoyenAcces(b.id)"  role="button"></i>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col class="m-auto">
              <small>Un montant de <strong class="text-success">{{totalCost}}€</strong> sera facturé au locataire en <span class="text-success">{{nextMonthLib}}</span></small>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="m-auto p-0 ">
              <b-button class="mt-2 bg-amsom" @click="validateFacturation()" variant="success"
                        id="valider-reaffecter-sollicitation"
                        :disabled="moyenAccesList.length==0 || facturation">Facturer
              </b-button>
            </b-col>
          </b-row>
        </b-overlay>
      </b-container>
</template>

<script>

import toast from "@/js/toast";
import moment from 'moment';

export default {
  name: "FacturerBadge",
  data() {
    return {
      contrat: null,
      sollicitation: null,
      // MoyenAccess
      selectedMoyenAcces: null,
      selectedCouleur: null,
      addedMoyenAccess:[],
      facturation: false,
    }
  },
  methods: {
    showFactureMoyenAcces(){
      this.selectedMoyenAcces = null;
      this.selectedCouleur = null;
      this.addedMoyenAccess = [];
      this.facturation = false;
      this.$bvModal.show('bv-modal-facturer-moyenAcces');
      this.$store.dispatch('moyenAcces/loadMoyenAccesFromAPI')
      .then(()=>{
        this.selectedMoyenAcces = this.$store.getters['moyenAcces/getMoyenAcces'][0].type
      })
      .catch(e=>{
        console.log("Erreur lors du chargement des Moyens d'accès: "+ e)
      }
      );
    },    

    addMoyenAcces(){
      let moyenAcces;
      if (this.couleurOptions && this.selectedCouleur)
        moyenAcces = this.$store.getters['moyenAcces/getMoyenAccesByTypeAndCouleur'](this.selectedMoyenAcces, this.selectedCouleur);
      else
        moyenAcces = this.$store.getters['moyenAcces/getMoyenAccesByType'](this.selectedMoyenAcces);
      this.addedMoyenAccess.push(moyenAcces);
    },

    removeMoyenAcces(id){
      this.addedMoyenAccess = this.addedMoyenAccess.filter(b=>b.id != id)
    },

    async validateFacturation(){
      this.facturation = true;
      let comment = 'Fourniture de ';

      comment+=this.moyenAccesList
        .map(ma=>{
          if (ma.couleur)
            return ma.count + ' ' + ma.libelletype + ' ' + ma.couleur;
          else
            return ma.count + ' ' + ma.libelletype;
        })
        .join(',');

        comment += ' pour un montant de ' + this.totalCost + '€ facturés en ' + this.nextMonthLib;
        this.$store.dispatch('moyenAcces/facturerMoyenAcces', {
          ctct: 'L', 
          cnct: this.contrat, 
          totalCost: this.totalCost, 
          date: this.nextMonth.format('DD/MM/YYYY'), 
          comment: comment,
          rclexe: this.splitedId[0], 
          rclnum: this.splitedId[1], 
          rclnlig: this.splitedId[2]
        })
        .then(()=>{
          toast.showToast('success', comment, 8000);
          this.$router.push({name: 'fichesuivi', params: { id : this.sollicitation } });
        })
        .catch((e)=>{
          console.log(e)
          toast.showToast('error', e, 4000);
        })
        .finally(()=>{
          this.facturation = false;
        });
    },

  },
  computed: {
    splitedId() {
      return this.sollicitation.split('-')
    },
    moyenAccesOptions(){
      if (!this.$store.getters['moyenAcces/getMoyenAcces'])
        return null;
      else
      return this._.uniqWith(
        this.$store.getters['moyenAcces/getMoyenAcces']
          .map(ma=>
          {
            return {
              value:ma.type, 
              text:ma.libelletype
            }
          })
        , this._.isEqual);
    },
    couleurOptions(){
      if (!this.selectedMoyenAcces)
        return null
      else{
        let colors = this.$store.getters['moyenAcces/getCouleurByType'](this.selectedMoyenAcces);
        if (colors)
          return colors.map(c=>{
            return {value: c, text: c} 
          });
        else
          return null;
      }
    },
    moyenAccesList(){
      return this._.uniqWith(this.addedMoyenAccess.map(res=>{
        res.count = this.addedMoyenAccess.filter(all=>all.id == res.id).length;
        return res;
      }), this._.isEqual);
    },
    totalCost(){
      return this.addedMoyenAccess.reduce((sum, b)=> sum + b.prix, 0);
    },

    // Autre
    nextMonth(){
      return moment().add(1, "months");
    },
    nextMonthLib(){
      moment.locale('fr');
      return this.nextMonth.format("MMMM YYYY");
    },
  },
  mounted() {
    if (this.$route.query.contrat)
      this.contrat = this.$route.query.contrat;
    else
    {
      toast.showToast('error', "Contrat introuvable, merci de réessayer", 6000);
      this.$router.go(-1);
    }
    if (this.$route.query.sollicitation)
      this.sollicitation = this.$route.query.sollicitation;
    else
    {
      toast.showToast('error', "Sollicitation introuvable, merci de réessayer", 6000);
      this.$router.go(-1);
    }
    this.$store.dispatch('moyenAcces/loadMoyenAccesFromAPI')
      .then(()=>{
        this.selectedMoyenAcces = this.$store.getters['moyenAcces/getMoyenAcces'][0].type
      })
      .catch(e=>{
        console.log("Erreur lors du chargement des Moyens d'accès: "+ e)
      });
  },
}
</script>
